module.exports = __webpack_public_path__ + "static/19-ESP-SANGRIA.15e1d72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/19-ESP-SANGRIA.png
// module id = 615
// module chunks = 35783957827783